import "../sparkle_namespace.js";
import "#vendor/slick.js";
import "../../../../../lib/assets/stylesheets/slick/slick-theme-overrides-sparkle.scss";

window.Sparkle ??= {};
window.Sparkle.Components ??= {};

Sparkle.Components.Slider = {
  /**
   * @name initialize
   * @description
   *  Factory function for creating a new instance of the slick carousel
   *   slider, as well as setting basic defaults
   *
   * @param {HTMLElement|jQuery} element
   * @param {object} config
   */
  initialize: function (elements, config) {
    elements = jQuery(elements);

    if (!elements.length) {
      return jQuery.Deferred().reject().promise();
    }

    if (jQuery.fn.slick) {
      this.decorate(elements, config);
      return jQuery.Deferred().resolve().promise();
    }

    return jQuery.when().then(
      function () {
        this.decorate(elements, config);
      }.bind(this),
    );
  },

  decorate: function (elements, config) {
    config = jQuery.extend(
      {
        dots: false,
      },
      config,
    );

    elements.each(function () {
      // only initialize this element if it's not already initialized.
      // there are times, like when we're converting a shared component to
      // a unique component, when initialize is being called on elements
      // that already have the slick carosel initialized. this probably
      // isn't what we want, so if you want to debug that issue, you can
      // drop a debugger in an else block on this branching logic.
      if (jQuery(this).hasClass("slick-initialized")) {
        return;
      }

      const $el = jQuery(this);
      $el.slick(config);

      // slick computes `slideWidth = listWidth / slidesToShow` once at init,
      // then relies on `window.load` to call `setPosition()` again so the
      // measurement reflects images / fonts / layout that finished after
      // init. Under Sprockets the bundle was big enough that init happened
      // before `load` fired, so the listener caught it. Under Vite dev,
      // ESM-deferred modules can attach the `load.slick` handler after the
      // event has already fired, so the recompute never happens — slick
      // gets stuck with a wrong `slideWidth` (commonly tiny like 84px when
      // the parent flex/grid hadn't sized yet at init), squashing the
      // slides.
      //
      // Watch the slick list (`<div class="slick-list">`) for size changes
      // and call `setPosition()` whenever its width changes. This catches
      // every layout shift after init — flex/grid parent settling, font
      // metrics, image dimensions — without guessing at fixed delays.
      // ResizeObserver fires once synchronously after observe() with the
      // current size, so we ignore the first emission and react only to
      // genuine subsequent changes.
      if (typeof ResizeObserver === "function") {
        const list = $el.parent(".slick-list")[0] || $el[0];
        let lastWidth = list.getBoundingClientRect().width;
        let initialFire = true;
        const observer = new ResizeObserver(function (entries) {
          if (initialFire) {
            initialFire = false;
            return;
          }
          const width = entries[0]?.contentRect?.width ?? lastWidth;
          if (width === lastWidth) {
            return;
          }
          lastWidth = width;
          if ($el.hasClass("slick-initialized")) {
            $el.slick("setPosition");
          }
        });
        observer.observe(list);
        $el.one("destroy", function () {
          observer.disconnect();
        });
      }
    });
  },
};
